"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UITypeaheadResultsItem = _interopRequireDefault(require("UIComponents/typeahead/results/UITypeaheadResultsItem"));

var _default = (0, _createReactClass.default)({
  displayName: "TokenResultItem",
  propTypes: {
    option: _propTypes.default.object.isRequired,
    highlighted: _propTypes.default.bool.isRequired,
    disabled: _propTypes.default.bool,
    onMouseDown: _propTypes.default.func
  },
  handleMouseDown: function handleMouseDown(e) {
    var _this$props = this.props,
        option = _this$props.option,
        onMouseDown = _this$props.onMouseDown;
    e.preventDefault();
    e.stopPropagation();

    if (onMouseDown) {
      onMouseDown(option);
    }
  },
  render: function render() {
    var _this$props2 = this.props,
        option = _this$props2.option,
        highlighted = _this$props2.highlighted,
        disabled = _this$props2.disabled;
    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      highlighted: highlighted,
      disabled: disabled,
      option: option,
      onMouseDown: this.handleMouseDown,
      "aria-pressed": true
    });
  }
});

exports.default = _default;
module.exports = exports.default;